import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sso-websiteurl',
  templateUrl: './sso-websiteurl.component.html',
  styleUrl: './sso-websiteurl.component.css'
})
export class SsoWebsiteurlComponent implements OnInit {

  showPopup = true;

  ngOnInit(): void { }

  redirect() {
    window.location.href = 'https://mssidc.maharashtra.gov.in/';
  }

  //cancel() {
  //  this.showPopup = false;
  //  // Optional: redirect somewhere else
  //  window.history.back();
  //}
  cancel() {
    window.location.href = 'https://ubp.msme.gov.in/home';
  }
}
